import { render, staticRenderFns } from "./ltzjjx1.vue?vue&type=template&id=bbdc9272&scoped=true&"
import script from "./ltzjjx1.vue?vue&type=script&lang=js&"
export * from "./ltzjjx1.vue?vue&type=script&lang=js&"
import style0 from "./ltzjjx1.vue?vue&type=style&index=0&id=bbdc9272&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdc9272",
  null
  
)

export default component.exports